const notLaunch = entries => {
  if (!entries || entries.length === 0 || entries === undefined) return []

  return entries.filter((entry, index) => {
    return entry.launched === false
  })
}

export default notLaunch
